import { render, staticRenderFns } from "./PersonInfoSummary.vue?vue&type=template&id=284b6d3b&scoped=true&"
import script from "./PersonInfoSummary.vue?vue&type=script&lang=js&"
export * from "./PersonInfoSummary.vue?vue&type=script&lang=js&"
import style0 from "./PersonInfoSummary.vue?vue&type=style&index=0&id=284b6d3b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b6d3b",
  null
  
)

export default component.exports